import { cn } from '../utilities.ts'
import { IconProps, IconType } from './types.ts'

export const DashboardIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-category', type, className)}></i>
}

export const MarketplaceIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-shop', type, className)}></i>
}

export const PaymentsIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-dollar', type, className)}></i>
}

export const ReimbursementIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-discount', type, className)}></i>
}

export const NotificationsIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-notification', type, className)}></i>
}

export const HelpCenterIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-question-2', type, className)}></i>
}

export const MyAccountIcon = ({
  type = IconType.Filled,
  className,
}: IconProps) => {
  return <i className={cn('ki-user', type, className)}></i>
}

export const HomeIcon = ({ type = IconType.Outline, className }: IconProps) => {
  return <i className={cn('ki-home', type, className)}></i>
}

export const AssessmentsIcon = ({type = IconType.Outline, className}:IconProps) => {
  return <i className={cn('ki-questionnaire-tablet', type, className)}></i>
}

export const HandbookIcon = ({type = IconType.Outline, className}:IconProps) => {
  return <i className={cn('ki-book-open', type, className)}></i>
}